<div class="status-label-wrapper" [ngClass]="config?.colorClass">
  <ng-container *ngIf="showDropdown; else badgeOnly">
    <!-- Show loading state while options are being loaded -->
    <div *ngIf="!selectOptions || selectOptions.length === 0" class="status-loading">
      Loading options...
    </div>

    <!-- Angular Material dropdown -->
    <mat-select
      class="ag-cell-editor-input"
      [(ngModel)]="selectedOption"
      #matSelect
      [disabled]="readonly"
      disableOptionCentering
      (selectionChange)="onDropdownChange($event.value)"
      [panelClass]="'ag-grid-select-panel'">
      <mat-select-trigger>
        <mat-icon *ngIf="selectedOption" [style.color]="selectedOption.color" style="margin-right: 6px; vertical-align: middle;">
          {{ selectedOption.icon }}
        </mat-icon>
        <span *ngIf="selectedOption">{{ selectedOption.label }}</span>
      </mat-select-trigger>
      <mat-option *ngFor="let option of selectOptions" [value]="option">
        <div class="status-option">
          <mat-icon [style.color]="option.color">{{ option.icon }}</mat-icon>
          <span>{{ option.label }}</span>
          
        </div>
      </mat-option>
    </mat-select>
  </ng-container>

  <ng-template #badgeOnly>
    <mat-icon
      aria-hidden="false"
      aria-label="Status icon"
      [fontIcon]="getStatusIcon(config?.label || statusV)"
      [ngStyle]="{
        'color': getStatusIconColor(config?.label || statusV),
        'font-size': '20px',
        'font-weight': '500',
        'border-radius': '2px',
        'min-width': '18px',
        'text-align': 'center',
        'padding': '2px',
        'line-height': '1',
        'display': 'inline-block'
      }"
    ></mat-icon>
    <span class="status-badge" [attr.title]="config?.description || config?.label">
      {{ config?.label || statusV }}
    </span>
  </ng-template>
</div>
